import { useApplicationContext } from 'shared/utils/applicationContext';

import { SuperAgentLevelView } from '../../components/SuperAgentLevelView';
import { getTooltipText } from './utils';

type TSuperAgentLevelViewContainerProps = {
  levelNumber: number;
  levelName: string;
};

const SUPER_AGENT_LEVEL = 4;

export const SuperAgentLevelViewContainer = ({ levelNumber, levelName }: TSuperAgentLevelViewContainerProps) => {
  const { config } = useApplicationContext();

  if (levelNumber !== SUPER_AGENT_LEVEL) {
    return null;
  }

  const tooltipText = getTooltipText(config);

  return <SuperAgentLevelView tooltipText={tooltipText} levelName={levelName} />;
};
